import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Spin, Button } from 'antd'
import {withTranslation} from 'react-i18next'
const {TextArea} = Input
@inject('emailListStore')
@observer
class FormModal extends Component {
  state = {
  }

  formRef = React.createRef()

  componentDidMount() {
  }

  handleOk = () => {
    const {emailListStore, handleCancel, groupId, taskId, type} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        "approveResult": '4',
        "groupId": groupId,
        "refuseReason": fieldsValue?.refuseReason,
        "taskId": taskId,
      }
      emailListStore.onAgreeAction(params, type).then(res=> {
        if (res?.data?.code === 0) {
          handleCancel()
        }
      })
    }).catch(() => {})
  }

  render() {
    const { emailListStore, addModalVisible, handleCancel, title, t } = this.props
    const {isFetchingAgree} = emailListStore
    return (
      <>
        <Modal
          title={t(`marketingManagement.refuseReason`)}
          closable={true}
          visible={addModalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk} >{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Spin spinning={isFetchingAgree}>
            <Form ref={this.formRef} key="addMapping" layout="vertical">
              <Row gutter={[10, 10]}>
                <Col span={24} >
                  <Form.Item name='refuseReason' label={t(`marketingManagement.refuseReason`)} rules={[{ required: true, message: `${t(`general.pleaseEnter`)} ${t(`marketingManagement.refuseReason`)}`}]}>
                    <TextArea maxLength={100} rows={4} placeholder={t(`general.pleaseEnter`)} style={{width: '100%'}} />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Spin>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
